(() => {
  if (window.TheManEmptyCartFocus) return;
  window.TheManEmptyCartFocus = true;
  const focusEmpty = () => {
    const drawer = document.getElementById('CartDrawer');
    const link = drawer?.querySelector('[data-tm-empty-shopping] a');
    if (!drawer?.classList.contains('drawer--is-open') || !link?.getClientRects().length || getComputedStyle(link).visibility === 'hidden') return;
    link.focus({ preventScroll: true });
  };
  document.addEventListener('drawerOpen.CartDrawer', () => requestAnimationFrame(focusEmpty));
  const observe = () => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    const isEmpty = () => drawer.classList.contains('is-empty') || drawer.classList.contains('atoz-cart-drawer--empty');
    let focusBelongsToDrawer = false;
    document.addEventListener('focusin', event => {
      if (event.target === document.body && focusBelongsToDrawer && drawer.classList.contains('drawer--is-open')) return;
      focusBelongsToDrawer = drawer.classList.contains('drawer--is-open') && drawer.contains(event.target);
    });
    document.addEventListener('pointerdown', event => {
      focusBelongsToDrawer = drawer.classList.contains('drawer--is-open') && drawer.contains(event.target);
    }, true);
    let wasEmpty = isEmpty();
    new MutationObserver(() => {
      const empty = isEmpty();
      if (!drawer.classList.contains('drawer--is-open')) focusBelongsToDrawer = false;
      if (empty && !wasEmpty && focusBelongsToDrawer) {
        requestAnimationFrame(() => {
          if (!focusBelongsToDrawer || !isEmpty() || !drawer.classList.contains('drawer--is-open')) return;
          const active = document.activeElement;
          if (drawer.contains(active) || active === document.body) focusEmpty();
        });
      }
      wasEmpty = empty;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true });
  else observe();
})();
